var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"deleteTweetCont"}},[(Number(_vm.currentUserInfo.userId) === Number(_vm.userId))?_c('img',{staticClass:"actionIcon",attrs:{"src":require("@/assets/images/trash.svg"),"alt":"recycle bin icon - delete tweet button"},on:{"click":function($event){return _vm.deleteTweet(_vm.tweetId)}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }